import { Grid, useGridMemory } from 'jrgrid';
import { pageEoRiView, pageRequestedItems, pageRequests } from './api';
import Navbar from '../../components/Navbar';
import { receivingPageColumns, filterButtonsReqItem, requestedItemColumns, eoRiViewColumns } from './utils';
import { Button, Row, Col } from 'react-bootstrap';
import React, { Fragment, useEffect, useState } from 'react';
import { Loader } from '../../components/Loader';
import { useSelector } from 'react-redux';

export const ReceivingPage = (props: any) => {
  const [refresh, setRefresh] = useState<boolean>(true);
  const [orders, setOrders] = useState(true);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));
  const [requestGridFilter, setReqeustGridFilter] = useState([]);
  const [itemGridFilter, setItemGridFilter] = useState([]);
  const gridMem = useGridMemory();

  const renderRequestGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid..' />;
    } else {
      let filter = [];

      return (
        <Grid
          amount={20}
          columns={receivingPageColumns}
          query={pageRequests}
          queryName='pageRequests'
          defaultSortField='id'
          globalFilters={[...requestGridFilter, ...filter]}
          // gridMemory={gridMem}
          csv={user.currentRole.isAdmin}
        />
      );
    }
  };

  const renderItemGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid..' />;
    } else {
      let filter = [];

      return (
        <Grid
          amount={20}
          columns={eoRiViewColumns}
          query={pageEoRiView}
          queryName='pageEoRiView'
          defaultSortField='id'
          
          globalFilters={[...itemGridFilter, ...filter]}
          // gridMemory={gridMem}
          csv={user.currentRole.isAdmin}
        />
      );
    }
  };

  useEffect(() => {
    if(window.location.href.includes('#items'))
      setOrders(false)
  }, [])

  return (
    <Fragment>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={8}>
            <Button
              key={0}
              className='mt-3 mb-3 ml-2'
              onClick={() => {
                setRefresh(true);
                setOrders(true);
                window.location.replace('/receiving')
              }}>
              Requests
            </Button>
            <Button
              key={1}
              className='mt-3 mb-3 ml-2'
              onClick={() => {
                setRefresh(true);
                setOrders(false);
                window.location.replace(window.location.href + '#items')
              }}>
              Request Items
            </Button>
          </Col>
          <Col md={4}>
            <h3 className='mt-3 mb-3 ml-2 mr-2 float-right'>{orders ? 'Showing All Requests' : 'Showing All Requested Items'}</h3>
          </Col>
        </Row>
        <div className='ml-2 mr-2'>{orders ? renderRequestGrid() : renderItemGrid()}</div>
      </div>
    </Fragment>
  );
};
